import { AccountFundingOption, FundingOptionsRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchFundingOptions() {
  const [fetching, setFetching] = useState(false);
  const [fundingOptions, setFundingOptions] = useState<AccountFundingOption[]>([]);

  async function fetchFundingOptions(params: FundingOptionsRequest) {
    try {
      setFetching(true);
      const res = await api.fetchFundingOptions(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      setFundingOptions(res.FundingOptions || []);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, fundingOptions, fetchFundingOptions };
}
